module.exports = __webpack_public_path__ + "static/media/marker.2c04b761.svg";